<template>
  <Modal v-model="show" title="邀请成员" :closable="true" @on-cancel=";(show = false), $emit('ok')" :mask-closable="false" :footer="false" width="600px">
    <p>通过链接邀请成员加入，复制下方链接发送给成员</p>
    <p class="info">
      <Input v-model="link" disabled />
      <Button type="primary" class="ml-10px" @click="copyLink()">复制链接</Button>
      <Button type="primary" class="ml-10px" @click="getInviteLink()">重置</Button>
    </p>
    <div slot="footer"></div>
  </Modal>
</template>
<script>
import { Input, Modal, Button, Message } from 'view-design'
export default {
  components: { Modal, Button, Input },
  props: {
    inviteVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    project_id: {
      type: Number,
      default: 0,
      required: true
    },
    detail: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      link: ''
    }
  },
  methods: {
    async getInviteLink() {
      const params = {
        uriCode: 'API027',
        project_id: +this.project_id
      }
      const res = await this.$fetch(params)
      const href = window.location.origin
      this.link = res ? `${href}/#/invite?invite=${res}&p_name=${this.detail.name}&inviter=${this.detail.username}&p_id=${this.detail.id}` : ''
    },
    copyLink() {
      let copyInput = document.createElement('input') //创建input元素
      document.body.appendChild(copyInput) //向页面底部追加输入框
      copyInput.setAttribute('value', this.link) //添加属性，将url赋值给input元素的value属性
      copyInput.select() //选择元素
      document.execCommand('Copy') //执行复制命令
      Message.success('链接已复制')
    }
  },
  computed: {
    show: {
      get() {
        return this.inviteVisible
      },
      set(val) {
        this.$emit('update:inviteVisible', val)
      }
    }
  },
  watch: {
    show(val) {
      if (val && this.detail.invite) {
        const href = window.location.origin
        this.link = `${href}/#/invite?invite=${this.detail.invite}&p_name=${this.detail.name}&inviter=${this.detail.username}&p_id=${this.detail.id}`
      } else if (val && !this.detail.invite) {
        this.getInviteLink()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.w100 {
  width: 100% !important;
}

.info {
  display: flex !important;
  flex-wrap: nowrap;
  justify-content: space-between;
  padding: 20px 0;
}

.ml-10px {
  margin-left: 10px !important;
}

.ivu-modal-footer {
  display: none !important;
}
</style>
